import {ChatClientUI} from "./view";
export class HoverControls
{
	constructor(private $root, private view : ChatClientUI)
	{
		this.disable();

		this.$root.find(".sxcc-ctrl li").on("mouseenter", (e) =>
		{
			if (this.view.giftPanel.isVisible()) return;
			$(e.currentTarget).addClass("hover");
		});

		this.$root.find(".sxcc-ctrl li").on("mouseleave", (e) =>
		{
			$(e.currentTarget).removeClass("hover");
		});
	}

	enable()
	{
		this.$root.addClass("sxc-enabled");
	}

	disable()
	{
		this.$root.removeClass("sxc-enabled");
	}

	reset()
	{
		this.$root.find(".sxcc-ctrl li").removeClass("hover");
	}

	public toggleFav(status : boolean)
	{
		this.$root.find(".sxccc-fav")
			.removeClass("sxccc-fav-no sxccc-fav-yes")
			.addClass("sxccc-fav-" + (status ? "yes" : "no"));
	}

	public toggleCamToCam(status : boolean)
	{
		this.$root.find(".sxccc-cam2cam")
			.removeClass("sxccc-cam2cam-no sxccc-cam2cam-yes")
			.addClass("sxccc-cam2cam-" + (status ? "yes" : "no"));
	}

	setSize(size: any)
	{
		this.$root.find("button[data-action=resize]").show();
		this.$root.find("button[data-action=resize][data-size=" + size + "]").hide();
	}

	private forceVisible : any = {};

	setForceVisible(s: string, b: boolean)
	{
		this.forceVisible[s] = b;

		let force = false;
		for (let item of Object.keys(this.forceVisible)) {
			if (this.forceVisible[item]) {
				force = true;
				break;
			}
		}

		this.$root[force ? "addClass" : "removeClass"]("hover");
	}

	showClose(b: boolean)
	{
		this.$root.find("[data-action=close]")[b ? "show" : "hide"]();
	}

	enableGift(b: boolean)
	{
		this.$root.find(".sxccc-gift")[b ? "show" : "hide"]();
	}
}
